import { css } from '@linaria/atomic';

export const modalBackdrop = css`
  background-color: rgba(0, 33, 82, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  -webkit-tap-highlight-color: transparent;
`;

export const modalBackdropBlur = css`
  backdrop-filter: blur(8px);
`;

/**
 * Anchors the backdrop to the bottom, adjusted by the runtime `heightOffset` (eg. desktop shell title bar).
 * The offset is provided at runtime via the `--modal-backdrop-height-offset` CSS variable.
 */
export const modalBackdropAdjustedHeight = css`
  height: calc(100% - var(--modal-backdrop-height-offset, 0px)) !important;
  bottom: 0 !important;
  top: auto !important;
`;

export const modalBackdropNonInteractive = css`
  pointer-events: none;
`;
